var React = require('react');

function SecuredCard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#989898;}.b{fill:#66a9f4;}")),React.createElement("rect",{"className":"a","width":"11.931","height":"1.404","key":1}),React.createElement("g",{"transform":"translate(0 2.808)","key":2},React.createElement("path",{"className":"a","d":"M0,75v5.615H7.79a3.514,3.514,0,0,1,3.44-2.808,3.35,3.35,0,0,1,.7.071V75Zm1.4,3.511v-1.4h2.1v1.4Zm5.615,0h-2.1v-1.4h2.1Z","transform":"translate(0 -75)"})),React.createElement("g",{"transform":"translate(8.423 7.019)","key":3},React.createElement("path",{"className":"b","d":"M229.911,190.308v-.7a2.1,2.1,0,1,0-4.208,0v.7H225v4.211h5.615v-4.211Zm-2.808,0v-.7a.7.7,0,1,1,1.4,0v.7Z","transform":"translate(-225 -187.5)"}))]);
}

SecuredCard.defaultProps = {"width":"14.038","height":"14.038","viewBox":"0 0 14.038 14.038"};

module.exports = SecuredCard;

SecuredCard.default = SecuredCard;
